import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import { translate } from "app/filters/i18nFilter";
import { DEVICES_TYPES_FOR_API } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import { sourceIcons } from "app/pages/activation/components/RankWidget/config";
import { sourceTexts } from "app/pages/activation/components/RankWidget/texts";

import * as SC from "./styles";

type SourceSchema = {
    source: DEVICES_TYPES_FOR_API;
    dataAutomation?: string;
};

export const Source = ({ source, dataAutomation }: SourceSchema) => {
    const iconName = sourceIcons[source] ?? sourceIcons[DEVICES_TYPES_FOR_API.DESKTOP];
    const text = sourceTexts[source] ?? sourceTexts[DEVICES_TYPES_FOR_API.DESKTOP];

    return (
        <SC.HeaderItemContainer data-automation={dataAutomation}>
            <SWReactIcons
                iconName={iconName}
                size="xs"
                iconColor={colorsPalettes.carbon[200]}
            />

            <SC.HeaderItemText>{translate(text)}</SC.HeaderItemText>
        </SC.HeaderItemContainer>
    );
};
